import {
    DELETE_WARNING,
    ListContext,
    ListContextValue,
    MenuItemType,
    newToast,
    Typography,
} from "@compass/core";
import { Permission, PermissionAction } from "generated/openApi";
import { useContext } from "react";
import { useDispatch } from "react-redux";
import { setAppToast } from "redux/reducers/appSlice";
import { isAuthorized } from "services";
import ApiService from "services/apiService";

export const useClassListMenuItems = (props: { permission: Permission; selectedIds: number[] }) => {
    const listContext = useContext<ListContextValue>(ListContext);
    const dispatch = useDispatch();
    const menuItems: MenuItemType[] = [];

    if (isAuthorized(props.permission, PermissionAction.Delete)) {
        menuItems.push({
            label: <Typography color="error">Delete ({props.selectedIds.length})</Typography>,
            action: () => {
                if (window.confirm(DELETE_WARNING)) {
                    ApiService.classes.deleteList(props.selectedIds).then(() => {
                        dispatch(setAppToast(newToast("success", "Successfully deleted selected classes.")));
                        listContext.clearSelectedIds?.();
                        listContext.loadList?.();
                    });
                }
            },
        });
    }

    return menuItems;
};